import { IUser } from "@imaginelearning/mps-api-service";
import AppWindow from "../../helpers/app-window";

const appWindow = AppWindow();

/**
 * Builds a launch URL for diagnostic assessments.
 * @param diagnosticSubject - The subject of the diagnostic assessment
 * @param user - The user object containing grade level information
 * @returns A fully formed URL string for launching the diagnostic assessment with appropriate parameters
 *          including return URLs for both complete and incomplete scenarios
 */
export default function buildLaunchUrl(diagnosticSubject: string, user: IUser, testNumber: number): string {
  const catSubject = diagnosticSubject.toLowerCase();
  const baseUrl = `${appWindow.STUDENT_ENV.REACT_APP_CAT_LAUNCH_URL}/${catSubject}`;
  const returnUrl = `https://${appWindow.location.host}/assessments/diagnostic-return`;
  const incompleteUrl = `${returnUrl}?incomplete=true`;
  const schoolYear = user.organization?.academicSession?.schoolYear || 0; // Default to 0 if not available
  let speechSettings = "";
  if (user.textToSpeech?.includes("IPA")) {
    speechSettings += "&tts=On";
  }
  if (user.languageTranslation?.includes("IPA")) {
    speechSettings += "&st=On";
  }
  if (catSubject === "math" && user.spanishLanguage?.includes("IPA")) {
    speechSettings += "&language=Spanish";
  }

  return `${baseUrl}?ipa=true&gradeLevel=${user.gradeLevel}&testNumber=${testNumber}&schoolYear=${schoolYear}${speechSettings}&returnUrl=${returnUrl}&incompleteUrl=${incompleteUrl}`;
}

// `${window.STUDENT_ENV.REACT_APP_CAT_LAUNCH_URL}/${catSubject}?gradeLevel=${updatedGrade}&testNumber=1&schoolYear=2025&returnUrl=https://${window.location.host}/liftoff${subPartURL}&incompleteUrl=https://${window.location.host}/liftoff/diagnostic-return?incomplete=true`
